export const NARRATIVE_ONLY_TOGGLE_FEATURE_FLAG = "narrative-only-toggle";

export function isNarrativeOnlyToggleEnabled(
  featureFlags?: string[] | null,
): boolean {
  return (featureFlags ?? []).includes(NARRATIVE_ONLY_TOGGLE_FEATURE_FLAG);
}
